import { Dialog, DialogContent, makeStyles } from '@material-ui/core';

import { useCreateQuote } from '../../hooks/create-quote.hook';
import { Organization } from '../../../organizations/types/organization.type';
import { CreateQuoteFormValues, CreateQuoteStepper } from '../Containers/CreateQuoteStepper.component';

type Props = {
  open: boolean;
  organization: Organization;
  organizationId: string;
  onCreated: () => void;
  onClose: () => void;
};

const useStyles = makeStyles({
  content: {
    padding: 0,

    '&:first-child': {
      paddingTop: 0,
    },
  },
});

export function CreateQuoteDialog({ open, organization, organizationId, onCreated, onClose }: Props) {
  const classes = useStyles();
  const { createQuote, isSubmitting } = useCreateQuote();

  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleSubmit = async (values: CreateQuoteFormValues) => {
    const created = await createQuote({ organizationId, ...values });
    if (created) {
      onCreated();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth scroll="paper">
      <DialogContent className={classes.content}>
        <CreateQuoteStepper organization={organization} onSubmit={handleSubmit} isSubmitting={isSubmitting} />
      </DialogContent>
    </Dialog>
  );
}
